"use client";

import { useEffect, useState } from "react";

/**
 * Kullanıcının cihaz tercihlerini birleştiren tek bir karar noktası.
 *
 * - `prefers-reduced-motion: reduce`  → Kullanıcı hareketli efektleri
 *   azaltmak istiyor (erişilebilirlik tercihi).
 * - `prefers-reduced-data: reduce`    → Kullanıcı veri tasarrufu modunda
 *   (örn. Chrome Lite mode, Android "Data saver"). iOS Safari henüz bu
 *   medya query'sini desteklemiyor; desteklemeyen tarayıcılarda `matches`
 *   false döner, yani tam deneyim sunulur.
 *
 * İkisinden biri aktifse WebGL, canvas, pahalı gradient veya otomatik
 * oynayan video gibi bileşenler yüklenmez; yerine hafif bir fallback
 * gösterilir.
 *
 * Dönüş değeri `null` → henüz hydrate olmadık (SSR ile aynı kararı verin).
 */
export function useReducedEnvironment(): boolean | null {
  const [reduced, setReduced] = useState<boolean | null>(null);

  useEffect(() => {
    const motionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    const dataQuery = window.matchMedia("(prefers-reduced-data: reduce)");

    function update() {
      setReduced(motionQuery.matches || dataQuery.matches);
    }

    update();

    motionQuery.addEventListener("change", update);
    dataQuery.addEventListener("change", update);
    return () => {
      motionQuery.removeEventListener("change", update);
      dataQuery.removeEventListener("change", update);
    };
  }, []);

  return reduced;
}
